import { render, staticRenderFns } from "./SaleHistory.vue?vue&type=template&id=0a4bf304&scoped=true"
import script from "./SaleHistory.vue?vue&type=script&lang=js"
export * from "./SaleHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4bf304",
  null
  
)

export default component.exports